/**
 * @file AnasysFrame.tsx
 *
 */

import { GenericFrame } from "../components/GenericFrame.tsx";
import { TopContents } from "./TopContents.tsx";
import { Ghs8atCoverSetting } from "./Ghs8atCoverSetting.tsx";
import { HowToDownloadAndInstall } from "./HowToDownloadAndInstall.tsx";
import { Download } from "./Download.tsx";
import { HowToInstallDeviceDriver } from "./HowToInstallDeviceDriver.tsx";
import { HowToDownloadDeviceDriver } from "./HowToDownloadDeviceDriver.tsx";
import { HelpAndSupport } from "./HelpAndSupport.tsx";
import { Version } from "./Version.tsx";
import { AnasysJis2004 } from "./AnasysJis2004.tsx";
import { Ghs8atMeasureConditions } from "./Ghs8atMeasureConditions.tsx";
import { useTranslation } from "react-i18next";

/**
 *
 * @returns アナシスダウンロードページの{JSX.Element}
 */
function AnasysFrame(): JSX.Element {
  const { i18n, t } = useTranslation();

  /**
   * ナビゲーションメニューの項目
   */
  const navItems = [
    { path: "/anasys", label: t("アナシストップ") },
    {
      path: "/anasys/Ghs8atCoverSetting",
      label: t("外ケース取り付け時の注意点"),
    },
    { path: "/anasys/Download", label: t("ダウンロード") },
    {
      path: "/anasys/HowToDownloadAndInstall",
      label: t("ダウンロードとインストールの手順"),
    },
    {
      path: "/anasys/HowToDownloadDeviceDriver",
      label: t("デバイスドライバーのダウンロード方法"),
    },
    {
      path: "/anasys/HowToInstallDeviceDriver",
      label: t("デバイスドライバーのインストール方法"),
    },
    {
      path: "/anasys/HelpAndSupport",
      label: t("トラブルシューティングとQandA"),
      children: [
        {
          path: "/anasys/HelpAndSupport/Ghs8atMeasureConditions",
          label: t("GHS-8AT測定値の扱いと各ロギング条件の動作説明"),
        },
      ],
    },
    {
      path: "/anasys/Version",
      label: t("バージョン情報"),
    },
  ];

  // 日本語が選択されている場合にのみ追加する要素
  if (i18n.language === "ja") {
    const helpAndSupportItem = navItems.find(
      (item) => item.path === "/anasys/HelpAndSupport"
    );
    if (helpAndSupportItem && helpAndSupportItem.children) {
      helpAndSupportItem.children.push({
        path: "/anasys/HelpAndSupport/AnasysJis2004",
        label: t("環境依存文字使用時の動作について"),
      });
    }
  }

  /**
   * 信頼できるURLのリスト
   */
  const trustedUrls = [
    "/anasys",
    "/anasys/Ghs8atCoverSetting",
    "/anasys/Download",
    "/anasys/HowToDownloadAndInstall",
    "/anasys/HowToDownloadDeviceDriver",
    "/anasys/HowToInstallDeviceDriver",
    "/anasys/HelpAndSupport",
    "/anasys/HelpAndSupport/AnasysJis2004",
    "/anasys/HelpAndSupport/Ghs8atMeasureConditions",
    "/anasys/Version",
  ];

  /**
   * ルーティング設定
   */
  const routes = [
    { path: "/", element: <TopContents /> },
    { path: "/Ghs8atCoverSetting", element: <Ghs8atCoverSetting /> },
    { path: "/Download", element: <Download /> },
    { path: "/HowToDownloadAndInstall", element: <HowToDownloadAndInstall /> },
    {
      path: "/HowToDownloadDeviceDriver",
      element: <HowToDownloadDeviceDriver />,
    },
    {
      path: "/HowToInstallDeviceDriver",
      element: <HowToInstallDeviceDriver />,
    },
    {
      path: "/HelpAndSupport",
      element: <HelpAndSupport />,
    },
    {
      path: "/HelpAndSupport/AnasysJis2004",
      element: <AnasysJis2004 />,
    },
    {
      path: "/HelpAndSupport/Ghs8atMeasureConditions",
      element: <Ghs8atMeasureConditions />,
    },
    {
      path: "/Version",
      element: <Version />,
    },
  ];

  //フレーム構成のコンポーネントを返す
  return (
    <GenericFrame
      navItems={navItems}
      trustedUrls={trustedUrls}
      routes={routes}
    />
  );
}

export default AnasysFrame;
